"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constant = require("../constant");
var getIsValid = function getIsValid(modelIn, section, errors) {
  if (modelIn === _constant.model.OPPORTUNITY) {
    switch (section) {
      case _constant.opportunitySection.AGG_DEMOGRAPHICS:
        return true;
      case _constant.opportunitySection.ADMINISTRATION:
        return !errors.applicationUrl && !errors.deliveryPreferences && !errors.recipients && !errors.applicantExtra && !errors.additionalLinks && !errors.contactFields;
      case _constant.opportunitySection.DETAILS:
        return !errors.title && !errors.type && !errors.description && !errors.caption && !errors.division && !errors.summary && !errors.detailed && !errors.locationType && !errors.city && !errors.state && !errors.compensationSubType && !errors.compensationAmount && !errors.startDay && !errors.startMonth && !errors.startYear && !errors.endDay && !errors.endMonth && !errors.endYear && !errors.employmentStartDay && !errors.employmentStartMonth && !errors.employmentStartYear && !errors.tips;
      case _constant.opportunitySection.QUALIFICATIONS:
        return !errors.experience && !errors.degrees && !errors.minGpa && !errors.majorCategories && !errors.languages && !errors.graduationMonth && !errors.graduationYear;
      default:
        return false;
    }
  }
  return false;
};
var _default = getIsValid;
exports.default = _default;